import { Box, Container } from "@mui/material";
import $ from "jquery";
import { useSelector } from "react-redux";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { BoardSearchListState, DialogMessageState, RiaBottomState, ToastMessageState } from "../../recoil/states";
import { RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";

const RiaBottom = () => {

    const BoardJokeNextListReducer_Result = useSelector((state: RootState) => state.BoardJokeNextListReducer); // 하단 Masonry 레이아웃 표시 처리를 위한 state
    const riaBottomState = useRecoilValue(RiaBottomState); // 하단 UI 랜더링 처리를 위해 사용되는 state
    const setBoardSearchListState = useSetRecoilState(BoardSearchListState); // 검색 화면 페이징 처리를 위해 사용되는 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state
    const setToastMessageState = useSetRecoilState(ToastMessageState); // 토스트 메세지 요청 정보를 갖는 state

    /**
     * 
     * @param e 이벤트 객체
     * @param req_type 요청 유형 (PREV / NEXT)
     */
    const handlerMovePage = async (e: React.MouseEvent<HTMLDivElement, MouseEvent>, req_type: string) => {

        let curr_page = parseInt(CommonUtil.getQuerystring("curr_page", "1"), 10);
        if (req_type === "PREV") {
            // 이전

            if (curr_page === 1) {
                const message = "첫번째 페이지 입니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
                return;
            }

            setBoardSearchListState(rawState => ({
                ...rawState,
                currPage: --curr_page
            }))
        }
        else if (req_type === "NEXT") {
            // 다음

            if (curr_page === BoardJokeNextListReducer_Result.n4TotalPage) {
                const message = "마지막 페이지 입니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
                return;
            }

            setBoardSearchListState(rawState => ({
                ...rawState,
                currPage: ++curr_page
            }))
        }
        else if (req_type === "CLIPBOARD") {
            // 클립보드 복사
            let isCopy = false; // 복사 성공 여부 (true / false)
            if (navigator.userAgent.indexOf(";UGGIYO_APP;") > -1) {
                // 앱 내 호출일 경우
                const url = $("head").find("[property='og:url']").attr("content") || "";
                const AppWebView = (window as any).AppWebView;
                isCopy = AppWebView.copy_Clipboard_Link_Url(url);
            }
            else {
                // 웹 브라우저 호출일 경우
                try {
                    const url = window.location.href;
                    isCopy = await navigator.clipboard.writeText(url).then(() => true).catch(err => false);
                }
                catch {
                    isCopy = false;
                }
            }
            const message = isCopy ? "클립보드에 복사되었습니다." : "클립보드 복사가 실패되었습니다.";
            setToastMessageState(rawState => ({ ...rawState, isShow: true, message }));
            return;
        }
        else {
            const message = "잘못된 호출 입니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            return;
        }

        // 브라우저 URL 주소 변경
        const { pathname } = window.location;
        const search_keyword = CommonUtil.getQuerystring("search_keyword", "");
        (window as any).urlChange(pathname + "?search_keyword=" + search_keyword + "&curr_page=" + curr_page);
    }

    return (
        <>
            <div className="ft" style={navigator.userAgent.indexOf(";UGGIYO_APP;") === -1 ? {} : { display: "none" }}>
                <Container maxWidth={false} className="root_max_width">
                    <div className="ft_copy">Copyright &copy; <b>우끼요</b> All rights reserved.&nbsp;&nbsp;<a href="/Personal_Desc.html" target="_blank" rel="noreferrer">개인정보취급방침</a></div>
                </Container>
            </div>
            <Box component="div" className="top_btn_area" sx={{ display: riaBottomState.currPathName !== "/board_info" ? "none" : { lg: "block", xs: "none" } }}>
                <div>
                    <a href="#none" title="엑스(구 트위터)" onClick={e => CommonUtil.handlerSnsShare(e, "twitter")}><img src="/images/btn_sns_twitter.png" width="35" alt="" /></a>
                </div>
                <div>
                    <a href="#none" title="페이스북" onClick={e => CommonUtil.handlerSnsShare(e, "facebook")}><img src="/images/btn_sns_facebook.png" width="35" alt="" /></a>
                </div>
                <div>
                    <a href="#none" title="네이버밴드" onClick={e => CommonUtil.handlerSnsShare(e, "band")}><img src="/images/btn_sns_naverband.png" width="35" alt="" /></a>
                </div>
                <div>
                    <a href="#none" title="네이버블로그" onClick={e => CommonUtil.handlerSnsShare(e, "naverblog")}><img src="/images/btn_sns_naverblog.png" width="35" alt="" /></a>
                </div>
                <div>
                    <a href="#none" title="핀터레스트" onClick={e => CommonUtil.handlerSnsShare(e, "pinterest")}><img src="/images/btn_sns_pinterest.png" width="35" alt="" /></a>
                </div>
                {/* 공유하기 기능 종료 됨..
                <div>
                    <a href="#none" title="카카오스토리" onClick={e => CommonUtil.handlerSnsShare(e, "kakaostory")}><img src="/images/btn_sns_kakaostory.png" width="35" alt="" /></a>
                </div> */}
                <div>
                    <a href="#none" title="카카오톡" onClick={e => CommonUtil.handlerSnsShare(e, "kakaotalk")}><img src="/images/btn_sns_kakaotalk.png" width="35" alt="" /></a>
                </div>
                <div>
                    <a href="#none" title="텀블러" onClick={e => CommonUtil.handlerSnsShare(e, "tumblr")}><img src="/images/btn_sns_tumblr.png" width="35" alt="" /></a>
                </div>
            </Box>
            {window.location.pathname !== "/image_maker" && (
                <Box component="div" className="top_btn_area_r"
                    sx={(theme) => ({
                        [theme.breakpoints.down('md')]: { right: 10 },   // < 1200px: xs~md 포함
                        // [theme.breakpoints.up('lg')]: { right: 'initial' } // 필요하면 상위 구간 리셋
                    })}
                >
                    <div style={{ display: riaBottomState.currPathName === "/board_search_list" ? "block" : "none", padding: "5px", marginBottom: "5px", cursor: "pointer", background: "#ffffff", filter: "alpha(opacity=30)", opacity: 0.3, MozOpacity: 0.3 }} onClick={(e) => handlerMovePage(e, "PREV")}>
                        <i className="fa fa-hand-o-left fa-2x" aria-hidden="true"></i>
                    </div>
                    <div style={{ display: riaBottomState.currPathName === "/board_search_list" ? "block" : "none", padding: "5px", marginBottom: "5px", cursor: "pointer", background: "#ffffff", filter: "alpha(opacity=30)", opacity: 0.3, MozOpacity: 0.3 }} onClick={(e) => handlerMovePage(e, "NEXT")}>
                        <i className="fa fa-hand-o-right fa-2x" aria-hidden="true"></i>
                    </div>
                    <div style={{ padding: "5px", marginBottom: "5px", cursor: "pointer", background: "#ffffff", filter: "alpha(opacity=30)", opacity: 0.3, MozOpacity: 0.3 }} onClick={(e) => handlerMovePage(e, "CLIPBOARD")}>
                        <i className="fa fa-link fa-2x" aria-hidden="true"></i>
                    </div>
                    <div style={{ padding: "5px", marginBottom: "5px", cursor: "pointer", background: "#ffffff", filter: "alpha(opacity=30)", opacity: 0.3, MozOpacity: 0.3 }} onClick={() => CommonUtil.scrollTo(0, 0, 200)}>
                        <i className="fa fa-arrow-circle-up fa-2x" aria-hidden="true"></i>
                    </div>
                </Box>
            )}
        </>
    )
}

export default RiaBottom;
